
import Vue from 'vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'CallBlock',
  mixins: [staticBlockMixin],
  props: {
    block: {
      type: Object,
      default: null
    },
    imageLimit: {
      type: Boolean,
      required: false,
      default: false
    },
    alignImage: {
      type: Boolean,
      required: true,
      default: false
    }
  }
})
